<div class="popup-container" *ngIf="visible">
  <div class="popup-content">
    <h2>Reset Your Password</h2>
    <p class="description">Create a password for your account.</p>

    <!-- New Password -->
    <div class="form-group">
      <label for="newPassword">New Password</label>
      <input
        id="newPassword"
        type="password"
        [(ngModel)]="model.newPassword"
        class="styled-input"
        placeholder="Enter New Password"
        #newPass="ngModel"
        
      />
      <small *ngIf="newPass.touched && !model.newPassword" class="text-danger">
        Enter New Password.
      </small>
      <small *ngIf="model.newPassword && model.newPassword.length < 6" class="text-danger">
        Password must be at least 6 characters.
      </small>
    </div>

    <!-- Confirm Password -->
    <div class="form-group">
      <label for="confirmPassword">Confirm Password</label>
      <input
        id="confirmPassword"
        type="password"
        [(ngModel)]="model.confirmPassword"
        class="styled-input"
        placeholder="Confirm Password"
        #confirmPass="ngModel"
       
      />
      <small *ngIf="confirmPass.touched && !model.confirmPassword" class="text-danger">
        Enter Confirm Password.
      </small>
      <small *ngIf="model.confirmPassword && model.confirmPassword !== model.newPassword" class="text-danger">
        Passwords do not match.
      </small>
    </div>

    <!-- Submit Button -->
    <div class="button-group">
      <button
        pButton
        type="button"
        class="btn-primary btn"
        [disabled]="!model.newPassword || model.newPassword.length < 6 || model.newPassword !== model.confirmPassword"
        (click)="onSubmit()"
      >
        Reset
      </button>
    </div>
  </div>
</div>
